const switchTypes = Object.freeze({
  LD: 'LD', // Launch Darkly
  SA: 'SA', // Store Attribute
});

const getStringifiedValue = (value) => JSON.stringify(value).replace(/"/g, '\\"');

const MINI_BAG_SWITCHES = [
  'chk-mini-bag-toaster-delay',
  'chk-display-badge-mini-bag',
  'chk-has-two-x-birthday-notification',
  'chk-use-mfe-add-to-bag-notification',
  'chk-has-include-tax-text-for-germany',
];

const BAG_SWITCHES = [
  {
    name: 'chk-save-for-later',
    key: 'chkSaveForLater',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-ois-start-session-with-fetch',
    key: 'chkOisStartSessionWithFetch',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-bag-repudiations-update',
    key: 'chkBagRepudiationsUpdate',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-apple-pay-pxp',
    key: 'chkHasApplePayPxp',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-apple-pay',
    key: 'chkHasApplePay',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-applepay-cart-post-delay',
    key: 'chkApplepaycartPostDelay',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: '0',
  },
  {
    name: 'pdp-trigger-quickview-on-load',
    key: 'pdpTriggerQuickviewOnLoad',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-display-badge-mini-bag',
    key: 'chkDisplayBadgeMiniBag',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-two-x-birthday-notification',
    key: 'chkHasTwoXBirthdayNotification',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-bag-mfe-v2',
    key: 'chkHasBagMfeV2',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-gift-with-purchase',
    key: 'chkGiftWithPurchase',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-mfe-use-ssr-in-shopping-bag',
    key: 'chkMfeUseSSRInShoppingBag',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'has-mfe-shopping-bag-recs-swatches-enabled',
    key: 'hasMfeShoppingBagRecsSwatchesEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-applepay-cart-put-delay',
    key: 'chkApplepayCartPutDelay',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: '1000',
  },
  {
    name: 'chk-use-promotions-v2',
    key: 'chkUsePromotionsV2',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'HasGiftBox',
    key: 'hasGiftBox',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'HasGiftReceipt',
    key: 'hasGiftReceipt',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'chk-use-daily-cache-busting-for-pxp',
    key: 'chkUseDailyCacheBustingForPxp',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-include-tax-text-for-germany',
    key: 'chkHasIncludeTaxTextForGermany',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'recommendations-hide-swatches-master-flag',
    key: 'hasHideSwatchesMasterFlagEnabled',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: getStringifiedValue({ 'shopping-bag-1': false }),
  },
];

const CHECKOUT_SWITCHES = [
  'chk-addr-verify-enabled',
  'chk-order-contact-info-mfe-enabled',
  'chk-addr-verify-accept-threshold',
  'chk-google-pay-pxp-script-url',
  'chk-google-pay-config',
  'chk-use-mfe-submit-button',
  'ful-sms-opt-in',
  'chk-hco-only-marketing-checkboxes',
  'ful-delivery-options-tabs',
  'ful-delivery-options-popins-modal',
  'ful-delivery-options-pudos-modal',
  'check-pay-pal-express-parameters-in-url',
  'ful-delivery-options-title',
  'chk-submit-overlay',
  'chk-has-apple-pay-pxp',
  'chk-applepay-cart-post-delay',
  'chk-has-checkout-page-header', // temporary switch for checkout page header to be loaded in checkout page
  'chk-has-apple-pay',
  'chk-use-state-as-country-googlepay',
  'chk-legal-submit-order-copy',
  'chk-sticky-bag-summary',
  'use-mfe-submit-button-for-cod-payment',
  'use-mfe-submit-button-for-apm-payment',
  'chk-has-mfe-submit-button-for-googlepay-payment',
  'chk-has-mfe-submit-button-for-paypal-payment',
  'chk-has-mfe-submit-button-for-standard-payment',
  'chk-mfe-recognize-customer',
  'chk-has-two-x-birthday-notification',
  'google-pay-script-url-override',
  'has-google-pay-2-1-0-script',
  'ful-chk-mfe-delivery-section',
  'has-mfe-legal-modals-enabled', // Legal link
  'chk-has-bag-mfe-v2',
  'chk-enable-franchise-country-repudiation-error-message',
  'chk-redirect-to-ocn-with-mfe',
  'chk-has-ios-marketing-subscribe',
  'chk-has-android-marketing-subscribe',
  'chk-applepay-cart-put-delay',
  'chk-use-daily-cache-busting-for-pxp',
  'chk-has-include-tax-text-for-germany',
  'chk-order-contact-to-top',
  'chk-charity-to-right',
  'chk-mfe-saved-shipping-address-enabled',
  'chk-mfe-shipping-address-enabled',
  'chk-mfe-billing-address-enabled',
  'chk-use-promotions-v2',
];

const CHECKOUT_SWITCHES_SSR = [
  {
    name: 'chk-addr-verify-enabled',
    key: 'chkAddrVerifyEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-order-contact-info-mfe-enabled',
    key: 'chkOrderContactInfoMfeEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-addr-verify-accept-threshold',
    key: 'chkAddrVerifyAcceptThreshold',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: getStringifiedValue(99),
  },
  {
    name: 'chk-google-pay-pxp-script-url',
    key: 'chkGooglePayPxpScriptUrl',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: 'https://api-integration.pxp-solutions.net/TokenVaultService/Content/gp.js',
  },
  {
    name: 'chk-google-pay-config',
    key: 'chkGooglePayConfig',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: getStringifiedValue({
      allowedCardNetworks: [
        'AMEX',
        'DISCOVER',
        'INTERAC',
        'JCB',
        'MASTERCARD',
        'VISA',
      ],
      allowedMethods: [
        'PAN_ONLY',
        'CRYPTOGRAM_3DS',
      ],
      amountStatus: 'FINAL',
      merchantNo: '123444',
      profile: 'prod',
    }),
  },
  {
    name: 'chk-use-mfe-submit-button',
    key: 'chkUseMfeSubmitButton',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'ful-sms-opt-in',
    key: 'fulSmsOptIn',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-hco-only-marketing-checkboxes',
    key: 'chkHcoOnlyMarketingCheckboxes',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'ful-delivery-options-tabs',
    key: 'fulDeliveryOptionsTabs',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'ful-delivery-options-popins-modal',
    key: 'fulDeliveryOptionsPopinsModal',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'ful-delivery-options-pudos-modal',
    key: 'fulDeliveryOptionsPudosModal',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'check-pay-pal-express-parameters-in-url',
    key: 'checkPayPalExpressParametersInUrl',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'ful-delivery-options-title',
    key: 'fulDeliveryOptionsTitle',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-submit-overlay',
    key: 'chkSubmitOverlay',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-apple-pay-pxp',
    key: 'chkHasApplePayPxp',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-applepay-cart-post-delay',
    key: 'chkApplepayCartPostDelay',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: getStringifiedValue(0),
  },
  {
    name: 'chk-has-checkout-page-header',
    key: 'chkHasCheckoutPageHeader',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-has-apple-pay',
    key: 'chkHasApplePay',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-use-state-as-country-googlepay',
    key: 'chkUseStateAsCountryGooglepay',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-legal-submit-order-copy',
    key: 'chkLegalSubmitOrderCopy',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-sticky-bag-summary',
    key: 'chkStickyBagSummary',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'use-mfe-submit-button-for-cod-payment',
    key: 'useMfeSubmitButtonForCodPayment',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'use-mfe-submit-button-for-apm-payment',
    key: 'useMfeSubmitButtonForApmPayment',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-has-mfe-submit-button-for-googlepay-payment',
    key: 'chkHasMfeSubmitButtonForGooglepayPayment',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-has-mfe-submit-button-for-paypal-payment',
    key: 'chkHasMfeSubmitButtonForPaypalPayment',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-has-mfe-submit-button-for-standard-payment',
    key: 'chkHasMfeSubmitButtonForStandardPayment',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-mfe-recognize-customer',
    key: 'chkMfeRecognizeCustomer',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-two-x-birthday-notification',
    key: 'chkHasTwoXBirthdayNotification',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'google-pay-script-url-override',
    key: 'googlePayScriptUrlOverride',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: getStringifiedValue({
      url: 'https://api-integration.pxp-solutions.net/TokenVaultService/Content/gp-2.1.0.js',
    }),
  },
  {
    name: 'has-google-pay-2-1-0-script',
    key: 'hasGooglePay_2_1_0_Script',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'ful-chk-mfe-delivery-section',
    key: 'fulChkMfeDeliverySection',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'has-mfe-legal-modals-enabled',
    key: 'hasMfeLegalModalsEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-has-bag-mfe-v2',
    key: 'chkHasBagMfeV2',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-enable-franchise-country-repudiation-error-message',
    key: 'chkEnableFranchiseCountryRepudiationErrorMessage',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-redirect-to-ocn-with-mfe',
    key: 'chkRedirectToOcnWithMfe',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-has-ios-marketing-subscribe',
    key: 'chkHasIosMarketingSubscribe',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-has-android-marketing-subscribe',
    key: 'chkHasAndroidMarketingSubscribe',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: true,
  },
  {
    name: 'chk-applepay-cart-put-delay',
    key: 'chkApplepayCartPutDelay',
    type: 'value',
    switchType: switchTypes.LD,
    defaultValue: getStringifiedValue(1000),
  },
  {
    name: 'chk-has-include-tax-text-for-germany',
    key: 'chkHasIncludeTaxTextForGermany',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-use-daily-cache-busting-for-pxp',
    key: 'chkUseDailyCacheBustingForPxp',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-order-contact-to-top',
    key: 'chkOrderContactToTop',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-charity-to-right',
    key: 'chkCharityToRight',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-mfe-saved-shipping-address-enabled',
    key: 'savedShippingAddressEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-mfe-shipping-address-enabled',
    key: 'chkMfeShippingAddressEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-mfe-billing-address-enabled',
    key: 'chkMfeBillingAddressEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'chk-use-promotions-v2',
    key: 'chkUsePromotionsV2',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'HasPurxSiteHeader',
    key: 'showPURXSiteHeader',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'HasPaymentSectionMFE',
    key: 'hasPaymentSectionMFE',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'HasGiftCardCheckoutRecaptcha',
    key: 'hasGiftCardCheckoutRecaptcha',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'InvisibleRecaptchaSiteKey',
    key: 'invisibleRecaptchaSiteKey',
    type: 'value',
    switchType: switchTypes.SA,
    defaultValue: '',
  },
  {
    name: 'HasGlobalReCaptcha',
    key: 'hasGlobalReCaptcha',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'HasPayOverTimeMessagingCheckout',
    key: 'showPayOverTime',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
];
const OCN_PAGE_SWITCHES = [
  {
    name: 'chk-use-mfe-marketing-subscribe',
    key: 'chkUseMfeMarketingSubscribe',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'has-order-confirmation-recommendations-enabled',
    key: 'hasOrderConfirmationRecommendationsEnabled',
    type: 'isOn',
    switchType: switchTypes.LD,
    defaultValue: false,
  },
  {
    name: 'HasOrderConfirmationPageMFE',
    key: 'hasOrderConfirmationPageMFE',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
  {
    name: 'StyliticsJSUrlOCP',
    key: 'styliticsJSUrlOCP',
    type: 'value',
    switchType: switchTypes.SA,
    defaultValue: 'https://web-assets.stylitics.com/purchase-tracking/latest/purchase_tracking_iife.js',
  },
  {
    name: 'StyliticsV3Locale',
    key: 'STYLITICS_LOCALE',
    type: 'value',
    switchType: switchTypes.SA,
    defaultValue: 'en-US',
  },
  {
    name: 'HasStyliticsOCP',
    key: 'hasStyliticsOCP',
    type: 'isOn',
    switchType: switchTypes.SA,
    defaultValue: false,
  },
];

const ADDRESS_TYPE = {
  popins: 'P',
  pudos: 'CP',
  homeDelivery: 'SB',
};

const SHIP_MODE_TYPE = {
  HOME_DELIVERY: 'HomeDelivery',
};

const STICKY_SUMMARY_HEADER_HEIGHT = 55;
const STICKY_SUMMARY_CONTAINER_CLASS = 'catalog-SmallScreenNavBar-module__navBar';
const FRANCHISE_COUNTRY_REPUDIATE = 'FRANCHISE_COUNTRY_REPUDIATE';
const PAYMENT_CURRENCY_GIFTCARD_REPUDIATE = 'PAYMENT_CURRENCY_GIFTCARD_REPUDIATE';
const PAYMENT_CURRENCY_PAYMENTMETHOD_REPUDIATE = 'PAYMENT_CURRENCY_PAYMENTMETHOD_REPUDIATE';

module.exports = {
  switchTypes,
  MINI_BAG_SWITCHES,
  BAG_SWITCHES,
  CHECKOUT_SWITCHES,
  CHECKOUT_SWITCHES_SSR,
  OCN_PAGE_SWITCHES,
  ADDRESS_TYPE,
  SHIP_MODE_TYPE,
  STICKY_SUMMARY_HEADER_HEIGHT,
  STICKY_SUMMARY_CONTAINER_CLASS,
  FRANCHISE_COUNTRY_REPUDIATE,
  PAYMENT_CURRENCY_GIFTCARD_REPUDIATE,
  PAYMENT_CURRENCY_PAYMENTMETHOD_REPUDIATE,
};
